const baseURL = "https://burakgundogan.net";

export default baseURL;
